import React, { useState, useMemo, useEffect } from "react";
import { useSelector } from "react-redux";
import { get } from "apiHelpers/api/ApiKit";
import { post } from "apiHelpers/api/ApiKit";
import useCurrentUser from "hooks/useCurrentUser";
import useSocket from "features/hooks/useSocket.io";
import BytePlusFloatingWidget from "./floating-widget";
import LiveStreamPlayer from "./live-stream-player";

const BYTE_PLUS_LIVE_STATUS = {
  LIVE: "Live",
  PREVIEW: "Preview",
  PLAYBACK: "Playback",
  OVER: "Over",
};

const ByteplusLiveStream = ({
  apiKey,
  streamUrl = "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
}) => {
  const [token, setToken] = useState(null);
  const [onGoingLiveStream, setOnGoingLiveStream] = useState({});
  const [showPreview, setShowPreview] = useState(false);
  const [fullScreenPlayer, setFullScreenPlayer] = useState(false);

  const { brandInfo } = useSelector((state) => state?.brandStorageReducer);
  const { currentUser } = useCurrentUser();
  const { webhookData } = useSocket({ refId: "byteplus-live-stream-status", apiKey: apiKey || brandInfo?.brand?._id });

  const isByteplusLiveStreamEnabled = useMemo(() => {
    return apiKey ? true : brandInfo?.activeIntegrations?.find(
      (integration) =>
        integration?.name === "BYTE_PLUS_LIVE" && integration?.isActive
    )
      ? true
      : false;
  }, [brandInfo?.activeIntegrations, apiKey]);

  const onGoingLiveStreamActivityId = useMemo(
    () => ({
      ...(webhookData ||  onGoingLiveStream || {}),
      activityId: Number(
        onGoingLiveStream?.activityId || webhookData?.activityId || "0"
      ),
    }),
    [onGoingLiveStream, webhookData]
  );

  const emitIframeSize = ({
    display = "none",
    visibility = "hidden",
    // border="none"
  } = {}) => {
    const styles = {
      common:{
        display,
        visibility,
      },
    }
    window.parent.postMessage({ type: "IFRAME_SIZE", styles }, "*");
  }

  const getOnGoingLiveStream = async () => {
    try {
      const response = await get("byteplus/get-on-going-live-stream", {
        params: {
          brandId:apiKey ? apiKey : brandInfo?.brand?._id,
        },
      });
      setOnGoingLiveStream(response?.data);
    } catch (error) {
      console.error("Error getting on going live stream:", error);
    }
  };
  // Note:
  //refer this link for more details https://docs.byteplus.com/en/cloud/video/live/develop/sdk-integration/web/start-live-stream
  // payload is mapped to required keys on backend
  const getClientSDKToken = async () => {
    if (token) {
      return;
    }

    try {
      const response = await post("byteplus/get-client-sdk-token", {
        brandId: onGoingLiveStreamActivityId?.brandId,
        activityId: onGoingLiveStreamActivityId?.activityId,
        mode: 1,
        nickName: currentUser?.user?.name || "anonymous" + "-" + Date.now(),
      });
      setToken(response?.data?.Result?.Token);
    } catch (error) {
      console.error("Error getting client SDK token:", error);
    }
  };

  // update the token when the webhook data changes
  useEffect(() => {
    if (
      onGoingLiveStreamActivityId?.status === BYTE_PLUS_LIVE_STATUS.LIVE &&
      onGoingLiveStreamActivityId?.activityId &&
      isByteplusLiveStreamEnabled
    ) {
      setShowPreview(true);
      getClientSDKToken();
      emitIframeSize({
        display: "block",
        visibility: "visible",
      });
      return;
    }
    if(onGoingLiveStreamActivityId?.status !== BYTE_PLUS_LIVE_STATUS.LIVE) {
      setShowPreview(false);
      emitIframeSize();
      return;
    }
  }, [onGoingLiveStreamActivityId, isByteplusLiveStreamEnabled, webhookData]);

  // check if any live stream is already on going
  useEffect(() => {
    if ((brandInfo?.brand?._id || apiKey) && !webhookData?.activityId) {
      getOnGoingLiveStream();
    }
  }, [brandInfo, webhookData, apiKey]);

  useEffect(() => {
    if (apiKey && showPreview?.toString() === "false") {
      setShowPreview(false);
      emitIframeSize();
      return;
    }
    emitIframeSize({
      display: "block",
      visibility: "visible",
    });
  }, [apiKey, showPreview]);


  // if (
  //   !showPreview ||
  //   !isByteplusLiveStreamEnabled ||
  //   !token ||
  //   !onGoingLiveStreamActivityId?.activityId ||
  //   onGoingLiveStreamActivityId?.status?.toLowerCase() !==
  //     BYTE_PLUS_LIVE_STATUS.LIVE.toLowerCase()
  // )
  //   return null;

  if (fullScreenPlayer) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }

  return (
    <>
      {showPreview && token && onGoingLiveStreamActivityId?.activityId && (
        <BytePlusFloatingWidget
          streamUrl={streamUrl}
          handleClosePreview={setShowPreview}
          onOpenStream={(val) => setFullScreenPlayer(val)}
          isFullScreenPlayer={fullScreenPlayer}
          apiKey={apiKey}
        >
          <LiveStreamPlayer
            activityId={onGoingLiveStreamActivityId?.activityId}
            token={token}
            isFullScreenPlayer={fullScreenPlayer}
          />
        </BytePlusFloatingWidget>
      )}
    </>
  );
};

export default ByteplusLiveStream;
